var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sched-app-timezone-selector"},[_c('label',{class:_vm.channelColorCSS},[_vm._v("Select Timezone")]),_c('v-select',{attrs:{"options":_vm.zones,"value":_vm.selected,"clearable":false},on:{"input":_vm.changed}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }